export default "__VITE_ASSET__C05s2tpf__"